import {
    Badge,
    Box,
    Button as ChakraButton,
    Flex,
    Grid,
    HStack,
    Icon,
    Input,
    Kbd,
    Stack,
    Text,
    VStack,
    RadioCard
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { PiHandWithdrawDuotone, PiHandDepositDuotone } from "react-icons/pi";
import { AiOutlineUser, AiOutlineMail, AiOutlinePhone } from "react-icons/ai";
import { useEffect, useState, useRef } from "react";
import { InputGroup } from "../Components/ui/input-group";
import { cryptoPayment } from "../Redux/Action/payments/cryptoPaymentAction";
import { stripePayment } from "../Redux/Action/payments/stripePaymentAction";
import { SiTether } from "react-icons/si";
import { TbTransfer } from "react-icons/tb";
import { AddressForm } from "../Components/custom/AddressForm";
import { getLocalStorageItem, notifyError } from "../Utils/Helper";
import { MdOpenInNew } from "react-icons/md";
import { CryptoCountdown } from "../Components/custom/CryptoCountdown";
import { WithdrawBank } from "../Components/custom/WithdrawBank";
import { CiBank, CiCreditCard1 } from "react-icons/ci";
import { FaCreditCard } from "react-icons/fa"; // Adding a different card icon
import { BankWire } from "../Components/custom/BankWire";
import { bankWireTransfer, getUserdata, ngeniusDeposit } from "../Redux/Action";
import { WithdrawCrypto } from "../Components/custom/WithdrawCrypto";
import { convertAEDtoUSD } from "../Utils/newHelper";
import { motion } from "framer-motion";
import { mt5DepositWidthDraw } from "../Redux/Action/mt5/mt5DepositWidthdraw";
import socketService from "../Utils/socketService";
import { ADD_BALANCE_PARAMS, AED_TO_USD_RATE } from "../Utils/Constants"
import { getDomainConfig } from "../Utils/dynamicBranding";
import { useAppTheme } from "../Hooks/useAppTheme";

const CustomDivider = ({ color, my = 4 }) => (
    <Box
        height="1px"
        bg={color}
        my={my}
        width="100%"
        borderRadius="full"
    />
);
const MotionBox = motion(Box);
export const WalletDeposit = ({ setRefresh, refresh, setLiveAccountDetails, setWithdrawalAmount, defaultPaymentType, activeTab, liveAccountDetails, dwtype }) => {
    const theme = useAppTheme();
    
    useEffect(() => {
        // Set page title dynamically based on domain
        const config = getDomainConfig();
        document.title = `Wallet Deposit - ${config.title}`;
    }, []);

    const userData = useSelector((state) => state?.Login?.userData);
    const whitelabelData = getLocalStorageItem("whitelabelData")

    const [finalBalance, setFinalBalance] = useState(userData?.balance);
    const [isDepositWithdraw, setIsDepositWithdraw] = useState(true);
    const [paymentType, setPaymentType] = useState("deposit");
    const [paymentMethod, setPaymentMethod] = useState("crypto");
    const [responseData, setResponseData] = useState({});
    const [amount, setAmount] = useState("");
    const [convertedUSD, setConvertedUSD] = useState("");
    const [isAddressDialogOpen, setIsAddressDialogOpen] = useState(false);
    const [isWithdrawBankOpen, setIsWithdrawBankOpen] = useState(false);
    const [isWithdrawCryptoOpen, setIsWithdrawCryptoOpen] = useState(false);
    const [isBankWire, setIsBankWire] = useState(false);
    const [transactionType, setTransactionType] = useState(false)
    const [showTimer, setShowTimer] = useState(null);
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({
        name: "",
        mobile: userData?.mobile,
        email: userData?.email,
        amount: "",
    });




    useEffect(() => {
        if (activeTab !== "wallet-deposit-widthdraw") {
            setWithdrawalAmount(0)
        }
        setWithdrawalAmount(0)
        setAmount("")
    }, [activeTab, transactionType, refresh])
    const [errorText, setErrorText] = useState("");
    useEffect(() => {
        if (defaultPaymentType) {
            setPaymentType(defaultPaymentType)
        }
    }, [defaultPaymentType, refresh])

    // Set payment method based on domain and payment type
    useEffect(() => {
        const isMoneyplantDomain = whitelabelData && whitelabelData.user_name === "moneyplantfxfze";

        if (paymentType === "deposit") {
            // For deposit, use stripe for moneyplant domain, crypto for others
            setPaymentMethod(isMoneyplantDomain ? "ngenius" : "crypto");
        } else {
            // For withdraw, stripe is not available, so use crypto
            setPaymentMethod("crypto");
        }
    }, [paymentType]); // Only run when paymentType changes, not when whitelabelData changes
    const handleChange = (e) => {
        const { name, value } = e.target;

        switch (name) {
            case "name": {
                const isValid = /^[a-zA-Z\s]*$/.test(value);
                if (isValid) {
                    setFormData((prev) => ({ ...prev, name: value }));
                    setErrorText("");
                } else {
                    setErrorText("Name can only contain alphabets and spaces.");
                }
                break;
            }

            case "mobile": {
                const digitsOnly = value.replace(/\D/g, "");
                setFormData((prev) => ({ ...prev, mobile: digitsOnly }));
                if (digitsOnly.length < 8 || digitsOnly.length > 15) {
                    setErrorText("Mobile number must be between 8 to 15 digits.");
                } else {
                    setErrorText("");
                }
                break;
            }

            case "email": {
                setFormData((prev) => ({ ...prev, email: value }));
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(value)) {
                    setErrorText("Please enter a valid email address.");
                } else {
                    setErrorText("");
                }
                break;
            }

            case "amount": {
                const digitsOnly = value.replace(/\D/g, "");
                setFormData((prev) => ({ ...prev, amount: digitsOnly }));
                const numericAmount = parseInt(digitsOnly, 10);
                if (!digitsOnly || numericAmount <= 0) {
                    setErrorText("Amount should be a positive integer greater than 0.");
                } else {
                    setErrorText("");
                }
                break;
            }

            default: {
                setFormData((prev) => ({ ...prev, [name]: value }));
                setErrorText("");
            }
        }
    };
    const handleSubmit = (e) => {
        e.preventDefault();

        const { name, mobile, email, amount } = formData;

        // Only check for empty strings after trimming (for string fields)
        const isAnyFieldEmpty = Object.values(formData).some((val) => {
            // If it's a string, check if it's empty after trimming
            if (typeof val === 'string') {
                return !val.trim();
            }
            // For non-string values, just check if they're falsy
            return !val;
        });
        if (isAnyFieldEmpty) {
            setErrorText("All fields are mandatory.");
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setErrorText("Invalid email format.");
            return;
        }

        const mobileRegex = /^\d{8,15}$/;
        if (!mobileRegex.test(mobile)) {
            setErrorText("Mobile number must be between 8 to 15 digits.");
            return;
        }

        const numericAmount = parseInt(amount, 10);
        if (isNaN(numericAmount) || numericAmount <= 0) {
            setErrorText("Amount must be a number greater than 0.");
            return;
        }

        setErrorText("");

        dispatch(
            bankWireTransfer({
                payload: formData,
                callback: (data) => {
                    setRefresh(prev => !prev)
                },
            })
        );
    };
    const inputRef = useRef();
    useEffect(() => {


        const eventName = `crypto_newStatus_${userData?._id}`;

        const handleStatusUpdate = (data) => {

            if (data.status !== "pending") {
                setShowTimer(false);
            }
        };

        socketService.on(eventName, handleStatusUpdate);

        return () => {
            socketService.off(eventName, handleStatusUpdate);
        };
    }, [userData?._id]);
    useEffect(() => {
        const aed = parseFloat(amount);
        if (!isNaN(aed)) setConvertedUSD(convertAEDtoUSD(aed));
        else setConvertedUSD("");
    }, [amount]);

    const allItems = [
        // { icon: <CiCreditCard1 />, value: "ngenius", title: "Visa/Master Card" },
        { icon: <TbTransfer />, value: "bankwiretransfer", title: "Bank Wire Transfer" },
        { icon: <SiTether />, value: "crypto", title: "Crypto" },
        ...(whitelabelData && whitelabelData.user_name === "moneyplantfxfze"
            ? [{ icon: <FaCreditCard />, value: "stripe", title: "Card Payments" }]
            : []),
        { icon: <CiBank />, value: "bank", title: "Bank" },

    ];

    // Filter items based on payment type
    const items =
        paymentType === "deposit"
            ? allItems.filter((item) => item.value !== "bank") // Exclude bank for deposit
            : allItems.filter((item) => item.value !== "bankwiretransfer" && item.value !== "ngenius" && item.value !== "stripe"); // Exclude certain methods for withdraw

    // Ensure the selected payment method is available in the items list
    useEffect(() => {
        if (items.length > 0 && !items.some(item => item.value === paymentMethod)) {
            // If the selected payment method is not available, select the first available one
            setPaymentMethod(items[0].value);
        }
    }, [items, paymentMethod]);

    const handleDepositWithdraw = (type) => {
        setTransactionType(prev => !prev)
        if (isDepositWithdraw && type === paymentType) {
            return;
        }

        if (isDepositWithdraw) {
            setPaymentType(type);
            setAmount("");
            // Set default payment method based on domain and payment type
            const isMoneyplantDomain = whitelabelData && whitelabelData.user_name === "moneyplantfxfze";
            if (type === "deposit") {
                setPaymentMethod(isMoneyplantDomain ? "ngenius" : "crypto");
            } else {
                setPaymentMethod("crypto");
            }
        } else {

            setPaymentType(type);
            setAmount("");
            setIsDepositWithdraw(true);
            // Set default payment method based on domain and payment type
            const isMoneyplantDomain = whitelabelData && whitelabelData.user_name === "moneyplantfxfze";
            if (type === "deposit") {
                setPaymentMethod(isMoneyplantDomain ? "ngenius" : "crypto");
            } else {
                setPaymentMethod("crypto");
            }
        }
    };


    const handleAmount = (value) => {
        setErrorText("")
        const cleanedValue = value.replace(/[^0-9.]/g, "");
        const numericValue = Number(cleanedValue);

        const isDeposit = paymentType === "deposit";
        const isWithdraw = paymentType === "withdraw";
        const isMT5 = dwtype === "mt5";
        const isWallet = dwtype === "wallet";

        let balance = 0;
        let applyBalanceCheck = true;
        let shouldSetWithdrawalAmount = true;

        if (isWallet && isWithdraw) {
            balance = Number(userData?.balance) || 0;
        } else if (isWallet && isDeposit) {

            applyBalanceCheck = false;
            shouldSetWithdrawalAmount = false;
        } else if (isMT5 && isDeposit) {
            balance = Number(userData?.balance) || 0;
        } else if (isMT5 && isWithdraw) {
            balance = Number(liveAccountDetails?.balance) || 0;
            shouldSetWithdrawalAmount = false;
        }


        if (applyBalanceCheck) {
            if (balance === 0) {
                setAmount("");
                setWithdrawalAmount(0);
                return;
            }

            if (numericValue > balance) {
                setAmount(balance);
                if (shouldSetWithdrawalAmount) {
                    setWithdrawalAmount(balance);
                }
                return;
            }
        }
        setAmount(cleanedValue);
        if (shouldSetWithdrawalAmount) {
            setWithdrawalAmount(numericValue);
        } else {
            setWithdrawalAmount(0);
        }
    };

    const handlePaymentGateway = () => {
        if (dwtype == "mt5") {
            if (!amount) {
                setErrorText("Please Enter Amount")
                return
            }
            setErrorText("")
            const paymentPayload = {
                amount: amount,
                accountNo: liveAccountDetails?.accountNo,
                paymentRoute: paymentType,
                email: userData?.email,
                paramtype: ADD_BALANCE_PARAMS
            }

            dispatch(mt5DepositWidthDraw({
                payload: paymentPayload,
                callback: (data) => {
                    if (data?.meta?.code === 200) {
                        setRefresh(prev => !prev)
                        dispatch(getUserdata());
                        setLiveAccountDetails(prev => {
                            if (!prev) return prev;

                            const numericAmount = Number(paymentPayload.amount);
                            let updatedBalance = prev.balance;

                            if (paymentPayload.paymentRoute === "deposit") {
                                updatedBalance += numericAmount;
                            } else if (paymentPayload.paymentRoute === "withdraw") {
                                updatedBalance -= numericAmount;
                            }

                            return {
                                ...prev,
                                balance: updatedBalance,
                            };
                        });
                    }
                }
            }));

        }
        else {
            if (!userData?.isAddresAdded && paymentMethod === "bank" && paymentType === "deposit") {
                notifyError("Please add an Address to proceed.");
                setIsAddressDialogOpen(true);
                return;
            }
            if (paymentType && paymentMethod && amount) {

                const base = { paymentType, paymentMethod, amount: Number(amount), accountno: userData?.accountno };
                if (paymentMethod === "crypto" && paymentType === "deposit") {
                    dispatch(cryptoPayment({
                        payload: base, callback: (data) => {
                            if (data?.meta?.code === 200) {
                                setShowTimer(true)
                                setResponseData(data?.data);
                                window.open(data?.data?.toOpenURL, "_blank");

                            }
                        }
                    }));
                } else if (paymentMethod === "bank" && paymentType === "deposit") {
                    sessionStorage.setItem("depositbank_payload", JSON.stringify(base));
                    window.open("/depositbank", "_blank");

                } else if (paymentMethod === "bank" && paymentType === "withdraw") {
                    setIsWithdrawBankOpen(true);
                } else if (paymentMethod === "crypto" && paymentType === "withdraw") {
                    setIsWithdrawCryptoOpen(true);
                } else if (paymentMethod === "ngenius" && paymentType === "deposit") {

                    const p2 = { paymentType, paymentMethod, amount: Number(amount), accountno: userData?.accountno, email: userData?.email };
                    dispatch(ngeniusDeposit({
                        payload: p2, callback: (data) => {
                            if (data?.meta?.code === 200) {

                                setAmount("");
                                setPaymentMethod("crypto");
                                window.open(data?.data?.paymentURL, "_blank");
                            }
                        }
                    }));
                } else if (paymentMethod === "stripe" && paymentType === "deposit") {

                    dispatch(stripePayment({
                        payload: { amount: Number(amount), accountno: userData?.accountno }, callback: (response) => {
                            if (response?.meta?.code === 200) {

                                const stripeUrl = response?.data?.url || response?.data?.stripeUrl || response?.data?.paymentURL;
                                if (stripeUrl) {
                                    window.open(stripeUrl, "_blank");
                                    setAmount("");
                                }
                            }
                        }
                    }));
                }
            }
        }


    };
    const fetchUserData = () => {
        dispatch(getUserdata());
    };

    useEffect(() => {
        fetchUserData()
    }, [refresh])

    // Removed duplicate check - now handled at the App level

    return (
        <Box
            className="flex flex-col rounded-lg"
            width="100%"
            position="relative"
            height="100%"
            maxHeight="calc(100vh - 150px)"
            overflowY="auto"
            p={{ base: 3, sm: 5 }}
            style={{ backgroundColor: theme.bgCard, color: theme.textPrimary }}>
            <Flex justify="space-between" mb={{ base: 4, md: 6 }} flexDirection={{ base: "column", sm: "row" }} gap={{ base: 3, sm: 0 }}>
                <Box mb={{ base: 2, sm: 0 }}>
                    <Text fontSize="sm" style={{ color: theme.textSecondary }}>Balance</Text>
                    <Badge bg={theme.brandPrimary} color={theme.iconText} fontSize="lg" padding={2} minWidth="120px" textAlign="center">
                        {
                            dwtype === "mt5"
                                ? (
                                    paymentType === "deposit"
                                        ? `$${parseFloat(liveAccountDetails?.balance ?? 0).toFixed(2)}`
                                        : `$${parseFloat((liveAccountDetails?.balance ?? 0) - (amount ?? 0)).toFixed(2)}`
                                )
                                : (
                                    paymentType === "deposit"
                                        ? `$${parseFloat((userData?.balance < 0 ? 0 : userData?.balance) ?? 0).toFixed(2)}`
                                        : `$${parseFloat(((userData?.balance < 0 ? 0 : userData?.balance) ?? 0) - (amount ?? 0)).toFixed(2)}`
                                )
                        }
                    </Badge>

                </Box>
                {

                    (() => {
                        const accountNo = dwtype === "mt5"
                            ? liveAccountDetails?.accountNo
                            : userData?.accountno;

                        if (accountNo && accountNo !== 0) {
                            return (
                                <Box textAlign={{ base: "left", sm: "right" }}>
                                    <Text fontSize="sm" style={{ color: theme.textSecondary }}>Account No.</Text>
                                    <Badge bg={theme.brandPrimary} color={theme.iconText} fontSize="lg" padding={2} minWidth="120px" textAlign="center">
                                        {accountNo}
                                    </Badge>
                                </Box>
                            );
                        }
                        return null;
                    })()
                }

            </Flex>

            {/* Responsive position for the toggle buttons */}
            <Box mb={6} zIndex={1}>
                <HStack spacing={3} wrap="wrap" justifyContent={{ base: "center", sm: "flex-start" }}>
                    <ChakraButton
                        leftIcon={<PiHandWithdrawDuotone />}
                        onClick={() => handleDepositWithdraw("deposit")}
                        bg={paymentType === "deposit" ? theme.buttonSuccessBg : theme.buttonSecondaryBg}
                        border={paymentType === "deposit" ? "none" : `1px solid ${theme.buttonSecondaryBorder}`}
                        color={paymentType === "deposit" ? theme.buttonSuccessText : theme.buttonSecondaryText}
                        _hover={{ opacity: 0.9, transform: "scale(1.02)" }}
                        padding={5}
                        width={{ base: "48%", sm: "auto" }}
                        justifyContent={{ base: "center", sm: "flex-start" }}
                    >
                        Deposit
                    </ChakraButton>
                    <ChakraButton
                        leftIcon={<PiHandDepositDuotone />}
                        onClick={() => handleDepositWithdraw("withdraw")}
                        bg={paymentType === "withdraw" ? theme.buttonDangerBg : theme.buttonSecondaryBg}
                        border={paymentType === "withdraw" ? "none" : `1px solid ${theme.buttonSecondaryBorder}`}
                        color={paymentType === "withdraw" ? theme.buttonDangerText : theme.buttonSecondaryText}
                        _hover={{ opacity: 0.9, transform: "scale(1.02)" }}
                        padding={5}
                        width={{ base: "48%", sm: "auto" }}
                        justifyContent={{ base: "center", sm: "flex-start" }}
                    >
                        Withdraw
                    </ChakraButton>
                </HStack>
            </Box>

            {showTimer && (
                <VStack spacing={2} mb={6} align="flex-start">
                    <Text fontSize="md" style={{ color: theme.error }}>You have a pending Crypto payment.</Text>
                    <ChakraButton bg={theme.buttonSuccessBg} color={theme.buttonSuccessText} onClick={() => window.open(userData?.pendingCryptoData?.toOpenURL, "_blank")}
                        width={{ base: "100%", md: "auto" }}>
                        <MdOpenInNew /> Complete Pending Payment <CryptoCountdown startTime={userData?.pendingCryptoData?.createdAt} />
                    </ChakraButton>
                </VStack>
            )}

            {isDepositWithdraw && (
                <Grid templateColumns={{ base: "1fr", md: dwtype !== "mt5" ? "1fr 2fr" : "1fr" }}
                    gap={{ base: 4, md: 6 }}
                    padding={{ base: 3, md: 5 }}
                    borderRadius="md"
                    minHeight={{ base: "auto", md: dwtype === "mt5" ? "200px" : "350px" }}
                    style={{ backgroundColor: theme.bgCard }}>
                    {
                        dwtype !== "mt5" && (
                            <Box position="relative">
                                <RadioCard.Root
                                    gap="4"
                                    width="100%"
                                    size="md"
                                    variant="outline"
                                    colorPalette="blue"
                                    value={paymentMethod}
                                    onValueChange={(e) => setPaymentMethod(e.value)}
                                >
                                    <RadioCard.Label style={{ color: theme.textPrimary, fontSize: 'lg', fontWeight: '600' }}>Payment Method</RadioCard.Label>
                                    <Box
                                        height="2px"
                                        my={3}
                                        width="100%"
                                        borderRadius="full"
                                        style={{
                                            background: `linear-gradient(90deg, transparent 0%, ${theme.brandPrimary} 50%, transparent 100%)`
                                        }}
                                    />
                                    <Stack spacing={3}>
                                        {items.map((item, index) => (
                                            <RadioCard.Item 
                                                key={`${item.value}-${index}`} 
                                                value={item.value}
                                                style={{
                                                    border: `2px solid ${paymentMethod === item.value ? theme.brandPrimary : theme.borderPrimary}`,
                                                    borderRadius: '8px',
                                                    transition: 'all 0.2s ease-in-out'
                                                }}
                                                _hover={{
                                                    borderColor: theme.brandPrimary,
                                                    transform: 'translateY(-1px)',
                                                    boxShadow: `0 2px 8px ${theme.brandPrimary}20`
                                                }}
                                            >
                                                <RadioCard.ItemHiddenInput />
                                                <RadioCard.ItemControl>
                                                    <RadioCard.ItemIndicator />
                                                    <RadioCard.ItemContent>
                                                        <HStack cursor="pointer">
                                                            <Icon fontSize="2xl" color={theme.brandPrimary}>{item.icon}</Icon>
                                                            <RadioCard.ItemText style={{ color: theme.textPrimary, fontWeight: paymentMethod === item.value ? '600' : '400' }}>{item.title}</RadioCard.ItemText>
                                                        </HStack>
                                                    </RadioCard.ItemContent>
                                                </RadioCard.ItemControl>
                                            </RadioCard.Item>
                                        ))}
                                    </Stack>
                                </RadioCard.Root>
                                {dwtype !== "mt5" && (
                                    <Box 
                                        position="absolute" 
                                        right="-3" 
                                        top="0" 
                                        bottom="0" 
                                        width="1px" 
                                        display={{ base: 'none', md: 'block' }}
                                        style={{
                                            background: `linear-gradient(180deg, transparent 0%, ${theme.brandPrimary} 30%, ${theme.brandPrimary} 70%, transparent 100%)`,
                                            opacity: 0.3
                                        }}
                                    />
                                )}
                            </Box>
                        )
                    }


                    <Box>
                        <VStack align="stretch" spacing={4}>
                            {paymentMethod !== "bankwiretransfer" && (
                                <>
                                    <InputGroup
                                        startElement={paymentMethod === "crypto" ? (dwtype === "mt5" ? "$" : "$") : paymentMethod === "ngenius" ? "د.إ" : paymentMethod === "stripe" ? "د.إ" : "$"}
                                        endElement={<Kbd>{paymentMethod === "crypto" ? "USDT" : paymentMethod === "ngenius" ? "AED" : paymentMethod === "stripe" ? "AED" : "USD"}</Kbd>}
                                    >
                                        <Input
                                            ref={inputRef}
                                            placeholder="Enter Amount"
                                            value={amount}
                                            onChange={(e) => {

                                                // Check balance based on account type (wallet vs MT5)
                                                const isMT5 = dwtype === "mt5";
                                                const balance = isMT5
                                                    ? (liveAccountDetails?.balance || 0)
                                                    : (userData?.balance || 0);

                                                if (balance <= 0 && paymentType === "withdraw") {
                                                    return;
                                                }
                                                handleAmount(e.target.value);
                                            }}
                                        />
                                    </InputGroup>
                                    {errorText ? (
                                        <Text
                                            fontSize="xs"
                                            style={{ color: theme.error }}
                                            animation="pulse 2s infinite"
                                        >
                                            {errorText}
                                        </Text>
                                    ) : (
                                        <Text fontSize="xs">&nbsp;</Text>
                                    )}
                                    {userData?.balance == 0 && paymentType == 'withdraw' && dwtype !== "mt5" && (
                                        <Text fontSize="xs" style={{ color: theme.error }}>You don't have sufficient balance in your account.</Text>
                                    )}
                                    {
                                        paymentType == 'deposit' && dwtype == "mt5" && userData?.balance == 0 && (
                                            <Text fontSize="xs" style={{ color: theme.error }}>You don't have sufficient balance in your account.</Text>
                                        )
                                    }
                                    {
                                        paymentType == 'withdraw' && dwtype == "mt5" && liveAccountDetails?.balance == 0 && (
                                            <Text fontSize="xs" style={{ color: theme.error }}>You don't have sufficient balance in your account.</Text>
                                        )
                                    }
                                </>


                            )}

                            {paymentMethod === "crypto" && paymentType === "deposit" && dwtype !== "mt5" && (
                                <Text fontSize="xs" style={{ color: theme.error }}>We support USDT TRC20 network.*</Text>
                            )}
                            {paymentMethod === "ngenius" && convertedUSD && (
                                <Text fontSize="xs" style={{ color: theme.success }}>{convertedUSD} USD will be added to your account</Text>
                            )}
                            {paymentMethod === "stripe" && amount && (
                                <Text fontSize="xs" style={{ color: theme.success }}>{(parseFloat(amount) / parseFloat(AED_TO_USD_RATE)).toFixed(2)} USD will be added to your wallet</Text>
                            )}

                            {paymentMethod === "bankwiretransfer" && paymentType === "deposit" ? (
                                <VStack spacing={4} align="stretch">
                                    <Grid templateColumns={{ base: "1fr", md: "1fr 1fr" }} gap={4}>
                                        <InputGroup startElement={<AiOutlineUser />} title="Name">
                                            <Input value={formData.name}
                                                onChange={handleChange} name="name" placeholder="Enter name" />
                                        </InputGroup>
                                        <InputGroup startElement={<AiOutlineMail />} title="Email">
                                            <Input value={formData.email}
                                                onChange={handleChange} name="email" placeholder="Enter email" type="email" />
                                        </InputGroup>
                                    </Grid>
                                    <Grid templateColumns={{ base: "1fr", md: "1fr 1fr" }} gap={4}>
                                        <InputGroup startElement={paymentMethod === "crypto" ? "₮" : paymentMethod === "ngenius" ? "د.إ" : "$"} title="Amount">
                                            <Input value={formData.amount}
                                                onChange={handleChange} name="amount"
                                                placeholder="Enter amount" />
                                        </InputGroup>
                                        <InputGroup startElement={<AiOutlinePhone />} title="Mobile Number">
                                            <Input value={formData.mobile}
                                                onChange={handleChange} name="mobile" placeholder="Enter mobile number" />
                                        </InputGroup>
                                    </Grid>
                                    {errorText ? (
                                        <Text
                                            fontSize="xs"
                                            style={{ color: theme.error }}
                                            animation="pulse 2s infinite"
                                        >
                                            {errorText}
                                        </Text>
                                    ) : (
                                        <Text fontSize="xs">&nbsp;</Text>
                                    )}
                                    <ChakraButton
                                        onClick={handleSubmit}
                                        isDisabled={!formData.amount || Number(formData.amount) <= 0}
                                        bg={!formData.amount || Number(formData.amount) <= 0 ? theme.buttonDisabledBg : theme.buttonPrimaryBg}
                                        color={!formData.amount || Number(formData.amount) <= 0 ? theme.buttonDisabledText : theme.buttonPrimaryText}
                                        _hover={{ bg: !formData.amount || Number(formData.amount) <= 0 ? undefined : theme.buttonPrimaryBg, opacity: 0.9 }}
                                        width={{ base: "100%", md: "auto" }}
                                    >
                                        Submit
                                    </ChakraButton>
                                </VStack>
                            ) : (
                                <ChakraButton
                                    onClick={handlePaymentGateway}
                                    isDisabled={!amount || Number(amount) <= 0}
                                    bg={!amount || Number(amount) <= 0 ? theme.buttonDisabledBg : theme.buttonPrimaryBg}
                                    color={!amount || Number(amount) <= 0 ? theme.buttonDisabledText : theme.buttonPrimaryText}
                                    _hover={{ bg: !amount || Number(amount) <= 0 ? undefined : theme.buttonPrimaryBg, opacity: 0.9 }}
                                    width={{ base: "100%", md: "auto" }}
                                >
                                    Submit
                                </ChakraButton>
                            )}
                        </VStack>
                    </Box>
                </Grid>
            )}

            {/* Modals */}
            {isAddressDialogOpen && <AddressForm isAddressDialogOpen={isAddressDialogOpen} setIsAddressDialogOpen={setIsAddressDialogOpen} />}
            {isWithdrawBankOpen && (
                <WithdrawBank
                    key={refresh}
                    isWithdrawBankOpen={isWithdrawBankOpen}
                    setIsWithdrawBankOpen={setIsWithdrawBankOpen}
                    amount={amount}
                    setAmount={setAmount}
                    setRefresh={setRefresh}
                    setFinalBalance={setFinalBalance}

                />
            )}
            {isWithdrawCryptoOpen && (
                <WithdrawCrypto
                    key={refresh}
                    isWithdrawCryptoOpen={isWithdrawCryptoOpen}
                    setIsWithdrawCryptoOpen={setIsWithdrawCryptoOpen}
                    amount={amount}
                    setAmount={setAmount}
                    setRefresh={setRefresh}
                    setFinalBalance={setFinalBalance}

                />
            )}

        </Box>
    );
};